export default __webpack_public_path__ + "static/media/prev.56d15953.svg";